/*
 Прелоадер первой загрузки (.js-preloader, логотип на белом фоне): показан
 сервером, App гасит его после первого монтирования.
*/
export function showPreloader(){
    $('.js-preloader').removeClass('is-hide');
}

export function hidePreloader(){
    setTimeout(function() {
        $('.js-preloader').addClass('is-hide');
    }, 300)
}

/*
 Индикатор загрузки страницы (SPA-переходы, фильтр, поиск, оформление заказа):
 полоса в 2 px по нижнему краю окна (.js-page-progress, разметка и стили —
 blocks/header.php).

 Поведение (решение заказчика 2026-09-11):
  - показывается сразу (SHOW_DELAY = 0 — решение заказчика 2026-09-11;
    положительное значение задерживает показ на столько миллисекунд, и
    переходы короче него проходят без индикатора вообще);
  - идёт до 90 % за LONG_AFTER — быстрый разгон (половина ширины за первую
    секунду) с замедлением к концу, затем (класс is-long) медленно ползёт
    к 98 %, чтобы на очень долгой загрузке не замирать; до 100 % сама не
    доходит, чтобы «полная» полоса не выглядела как завершение (кривые и
    сроки — в CSS, blocks/header.php);
  - не гаснет раньше MIN_VISIBLE после показа: быстрые ответы (AJAX-пагинация,
    SPA-переход из кеша) иначе дают вспышку короче глаза — полоса не успевает
    прочитаться как индикатор;
  - по завершении загрузки добегает до 100 % и гаснет.

 show/hide — прежняя пара (роутер показывает при SPA-переходе, App гасит в
 mounted/updated/watch struct, причём по нескольку раз за переход, поэтому
 вызовы не считаются: любой hide при отсутствии удержаний завершает показ).
 hold/release — удержание ленивыми страничными компонентами (app/lazy.js): пока
 хоть одна группа грузится, hide не срабатывает, иначе App.updated прятал бы
 индикатор до прихода компонента. Последний release гасит индикатор сам.
*/
const SHOW_DELAY = 0;     // задержка показа, мс; 0 — полоса появляется сразу
const MIN_VISIBLE = 700;  // минимум показа полосы, мс (к этому моменту она проходит ≈ 35 %)
const LONG_AFTER = 10000; // конец фазы 1 (90 %), дальше медленная фаза is-long — см. CSS
const DONE_TIME = 500;    // добег до 100 % (0,2 с) + затухание (0,3 с) — см. CSS .is-done

let holds = 0;
let active = false;      // идёт ожидание (между show и hide)
let visible = false;     // полоса на экране
let shownAt = 0;         // момент показа полосы (Date.now()), для MIN_VISIBLE
let showTimer = null;
let finishTimer = null;  // отложенное завершение, пока не истёк MIN_VISIBLE
let longTimer = null;
let doneTimer = null;

function bar(){
    return document.querySelector('.js-page-progress');
}

function reveal(){
    const el = bar();
    if (!el) {
        return;
    }
    visible = true;
    shownAt = Date.now();
    // сброс в исходное состояние без анимации, затем запуск заполнения
    el.classList.remove('is-visible', 'is-long', 'is-done');
    el.style.transition = 'none';
    void el.offsetWidth;
    el.style.transition = '';
    el.classList.add('is-visible');
    longTimer = setTimeout(function() {
        longTimer = null;
        el.classList.add('is-long');
    }, LONG_AFTER);
}

function finish(){
    const el = bar();
    visible = false;
    if (longTimer) {
        clearTimeout(longTimer);
        longTimer = null;
    }
    if (!el) {
        return;
    }
    el.classList.add('is-done');
    doneTimer = setTimeout(function() {
        doneTimer = null;
        el.classList.remove('is-visible', 'is-long', 'is-done');
    }, DONE_TIME);
}

function start(){
    active = true;
    if (finishTimer) {
        // новая загрузка до гашения — полоса продолжает идти, отложенное завершение снимается
        clearTimeout(finishTimer);
        finishTimer = null;
    }
    if (doneTimer) {
        clearTimeout(doneTimer);
        doneTimer = null;
    }
    if (visible || showTimer) {
        return;
    }
    if (SHOW_DELAY <= 0) {
        reveal();
        return;
    }
    showTimer = setTimeout(function() {
        showTimer = null;
        if (active) {
            reveal();
        }
    }, SHOW_DELAY);
}

function stop(){
    active = false;
    if (showTimer) {
        clearTimeout(showTimer);
        showTimer = null;
    }
    if (!visible || finishTimer) {
        return;
    }
    const rest = MIN_VISIBLE - (Date.now() - shownAt);
    if (rest > 0) {
        finishTimer = setTimeout(function() {
            finishTimer = null;
            finish();
        }, rest);
        return;
    }
    finish();
}

export function showCatalogPreloader(){
    start();
}

export function hideCatalogPreloader(){
    if (holds === 0) {
        stop();
    }
}

export function holdCatalogPreloader(){
    holds++;
    start();
}

export function releaseCatalogPreloader(){
    if (holds > 0) {
        holds--;
    }
    if (holds === 0) {
        stop();
    }
}
